import React, { useState } from "react";
import { SiniestrosEstados } from "../../coms/siniestros/SiniestrosEstados";
import { AsistenteInstrucciones, AsistenteSubirDocs } from "../../coms/siniestros/AsistenteSubirDocs";
import { FormularioZoho } from "./FormularioZoho";
import { SiniestrosCloseIcon } from "../../coms/siniestros/SiniestrosCloseIcon";

export const CredHospAmbulatorio = () => {
    const [historial, setHistorial] = useState([]);
    const [instrucciones, setInstrucciones] = useState(false);

    return (
        <div className={`siniestros-card ${instrucciones ? "bg-white" : "bg-primary"}`}>
            <div className="row">
                <AsistenteSubirDocs instrucciones={instrucciones} />
                {instrucciones && <AsistenteInstrucciones />}
                <div className={`${instrucciones ? "col-xl-6" : "col-xl-9"} xxx`}>
                    <div className={"overflow-hidden"}>
                        <SiniestrosEstados
                            historial={historial}
                            revision={true}
                            marginUp={true}
                            zohoFormItem={FormularioZoho}
                            hospitalario={true}
                            zoho2={true}
                            setInstrucciones={setInstrucciones}
                        />
                        {!instrucciones && <SiniestrosCloseIcon />}
                    </div>
                </div>
            </div>
        </div>
    );
};
